
export class OrederRemarks {
    configId: number;
    tenantId: string;
    visible: boolean;
    orderRemarksId: string;
    label: string;
    begRange: string;
    endRange: string;
    location: string;
    required: boolean;
    value: string;
    formGroup:string;
    constructor() {
        this.value = "";
    }
}